import { gql } from '@apollo/client';

export const DELETE_GUIDE_CATEGORY = gql`
    mutation DeleteGuideCategory($id: ID!) {
        deleteGuideCategory(id: $id) {
            id
        }
    }
`;
